export const messages = {
  'wre-dashboard.nav-menu.item.shared': 'Sharing',
  'wre-dashboard.nav-menu.item.backups': 'Backups',
  'wre-dashboard.nav-menu.item.machines': 'Machines',
  'wre-dashboard.nav-menu.item.account': 'Account',
  'wre-dashboard.search.input.hint': 'Search',
  'wre-dashboard.search.label.breadcrumb': 'Search results',
  'wre-dashboard.search.message.empty': 'No items match your search',
  'wre-dashboard.side-bar.selected.title:plural': '{count} item selected | {count} items selected',
  'wre-dashboard.side-bar.backup-type.disk': 'Disk',
  'wre-dashboard.side-bar.backup-type.file': 'File',
  'wre-dashboard.side-bar.backup-type.notarized': 'Notarized files and folders',
  'wre-dashboard.side-bar.backup-type.exchange': 'Application - Microsoft Exchange',
  'wre-dashboard.side-bar.backup-type.sql': 'Application - Microsoft SQL',
  'wre-dashboard.side-bar.backup-type.sys-state': 'Application - System state',
  'wre-dashboard.side-bar.backup-type.application': 'Application',
  'wre-dashboard.space-indicator.label.left': '{spaceFree} left',
  'wre-dashboard.space-indicator.label.used': '{usedSpace} used',
  'wre-dashboard.space-indicator.label.unlimited': 'Unlimited',
  'wre-dashboard.backups-table.column.name': 'Name',
  'wre-dashboard.backups-table.column.size': 'Size',
  'wre-dashboard.backups-table.column.version': 'Last backup',
  'wre-dashboard.backups-table.message.no-backups': 'There are no backups yet in Cloud',
  'wre-dashboard.backups-sidebar.label.size': 'Size',
  'wre-dashboard.backups-sidebar.label.type': 'Type',
  'wre-dashboard.backups-sidebar.label.version': 'Last version',
  'wre-dashboard.backups-sidebar.label.created': 'Created',
  'wre-dashboard.backups-sidebar.label.machine': 'Machine',
  'wre-dashboard.backups-sidebar.label.owner': 'Owner',
  'wre-dashboard.content-table.column.name': 'Name',
  'wre-dashboard.content-table.column.versions': 'Versions',
  'wre-dashboard.content-table.column.volumes': 'Volumes',
  'wre-dashboard.content-table.column.path': 'Path',
  'wre-dashboard.content-table.column.size': 'Size',
  'wre-dashboard.content-table.column.version': 'Last version',
  'wre-dashboard.content-table.action.versions': 'Versions',
  'wre-dashboard.content-table.action.restore': 'Download',
  'wre-dashboard.content-table.action.share': 'Share link',
  'wre-dashboard.content-table.label.size': 'Size',
  'wre-dashboard.content-table.label.created': 'Created',
  'wre-dashboard.content-table.label.modified': 'Modified',
  'wre-dashboard.content-table.message.empty-folder': 'This folder is empty',
  'wre-dashboard.password-dialog-box.title.backup': 'Encrypted backup',
  'wre-dashboard.password-dialog-box.title.archive': 'Encrypted archive',
  'wre-dashboard.password-dialog-box.message.backup': 'Please specify the password to access the backup {displayName}',
  'wre-dashboard.password-dialog-box.message.archive': 'Please specify the password to access the archive {displayName}',
  'wre-dashboard.password-dialog-box.hint.password': 'Password',
  'wre-dashboard.password-dialog-box.message.invalid-password': 'The password is incorrect',
  'wre-dashboard.form.button.open': 'Open',
  'wre-dashboard.form.button.close': 'Close',
  'wre-dashboard.form.button.cancel': 'Cancel',
  'wre-dashboard.form.button.delete': 'Delete',
  'wre-dashboard.shared-content-table.column.name': 'Name',
  'wre-dashboard.shared-content-table.column.location': 'Location',
  'wre-dashboard.shared-content-table.column.source': 'Source',
  'wre-dashboard.shared-content-table.column.days': 'Days',
  'wre-dashboard.shared-content-table.column.downloads': 'Downloads',
  'wre-dashboard.shared-content-table.column.shared': 'Shared on',
  'wre-dashboard.shared-content-table.label.shared': 'Shared on',
  'wre-dashboard.shared-content-table.label.backup': 'Source',
  'wre-dashboard.shared-content-table.action.share': 'Share link',
  'wre-dashboard.shared-content-table.action.settings': 'Link settings',
  'wre-dashboard.shared-content-table.action.delete': 'Delete link',
  'wre-dashboard.shared-content-table.action.delete-selected': 'Delete links',
  'wre-dashboard.account-page.message.used-space': '{brandName}: {spaceFree} free of {totalSpace}',
  'wre-dashboard.account-page.message.used-unlimited-space': '{brandName}: Unlimited space',
  'wre-dashboard.account-page.button.sign-out': 'Sign out',
  'wre-dashboard.account-page.button.manage-subscription': 'Manage license',
  'wre-dashboard.account-page.message.subscription.active': 'Your license for {brandName} space expires on',
  'wre-dashboard.account-page.message.subscription.trial': '{brandName} Trial is active until',
  'wre-dashboard.account-page.message.subscription.expired': 'Your license for {brandName} space expired on',
  'wre-dashboard.account-page.message.worm-status.storage-full': 'Your {brandName} storage is full. You cannot backup or archive data to the Cloud.',
  'wre-dashboard.account-page.message.worm-status.less-than': 'Less than {percent} percent is free. You will not be able to use {brandName} soon.',
  'wre-dashboard.versions-dialog-box.title': 'Versions of {fileName}',
  'wre-dashboard.shared-link-dialog-box.share-view.button.copy': 'Copy link',
  'wre-dashboard.shared-link-dialog-box.share-view.button.manage': 'Link settings',
  'wre-dashboard.shared-link-dialog-box.share-view.message': 'Anyone with this link can view the last version of the data',
  'wre-dashboard.shared-link-dialog-box.share-view.label.shared': 'Shared on {creationDate}',
  'wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied': 'Link Copied',
  'wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error': 'Link Copy Error',
  'wre-dashboard.shared-link-dialog-box.delete-view.title': 'Delete link',
  'wre-dashboard.shared-link-dialog-box.delete-view.message': 'This link will no longer work for anyone who has it',
  'wre-dashboard.shared-link-dialog-box.delete-selected-view.title': 'Delete links',
  'wre-dashboard.shared-link-dialog-box.delete-selected-view.message': 'These links will stop working for anyone who has them',
  'wre-dashboard.shared-link-dialog-box.manage-view.title': 'Link settings',
  'wre-dashboard.shared-link-dialog-box.manage-view.button.delete': 'Delete link',
  'wre-dashboard.shared-link-dialog-box.manage-view.button.apply': 'Done',
  'wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password': 'Password',
  'wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password': 'Reset password',
  'wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection': 'Password protection',
  'wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password': 'Protect this link by using a password',
  'wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration': 'Expiration',
  'wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits': 'Downloads limit',
  'wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural': 'Disable this link in {splitMarker} day | Disable this link in {splitMarker} days',
  'wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural': 'Disable this link after {splitMarker} download | Disable this link after {splitMarker} downloads',
  'wre-dashboard.sub-accounts-dialog-box.title': 'Accounts',
  'wre-dashboard.sub-accounts-dialog-box.search.input.hint': 'Search',
  'wre-dashboard.sub-accounts-dialog-box.table.message.empty': 'No items match your search',
  'wre-dashboard.sub-accounts-dialog-box.table.column.name': 'Name',
  'wre-dashboard.sub-accounts-dialog-box.table.column.usage': 'Usage',
  'wre-dashboard.sub-accounts-dialog-box.table.column.version': 'Last backup',
  'wre-dashboard.sub-accounts-dialog-box.table.column.expires': 'Expires',
  'wre-dashboard.sub-accounts-dialog-box.label.used-space': '{spaceFree} free of {totalSpace}',
  'wre-dashboard.sub-accounts-dialog-box.label.volume-subscription': 'Volume subscription',
  'wre-dashboard.sub-accounts-dialog-box.label.expired': 'Expired',
  'wre-dashboard.machines-table.column.name': 'Name',
  'wre-dashboard.machines-table.column.size': 'Size',
  'wre-dashboard.machines-table.message.no-machines': 'There are no machines yet in Cloud'
};
